import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "../../../Themecontext/Themecontext";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import {
    Search, ChevronDown, ChevronRight, FileText, X,
    Calendar, Box, TrendingUp, Info
} from "lucide-react";
import { LotNoSearch, LotPosition12, LotTakaDetail } from "../../../Redux/Slice/MillstageEntry/MillstageEntrySlice";
import Cookies from "js-cookie";

// Mock Same Lot Entries
const MOCK_SAME_LOTS = [
    { id: "lot-1", date: "20/03/2026", srNo: "000245", lotNo: "00391123", taka: 3, meter: 1140.0, party: "AAYUSH QUALITY", pty: "AUS", quality: "SATIN", group: "SINHA MASTER" },
    { id: "lot-2", date: "21/03/2026", srNo: "11/19/000001", lotNo: "009311AJJ", taka: 5, meter: 2200.0, party: "BHAKTI VELFAB", pty: "BKV", quality: "VELVET 9000", group: "VELVET MASTER" },
    { id: "lot-3", date: "22/03/2026", srNo: "03/23/000019", lotNo: "011711", taka: 2, meter: 850.5, party: "SHREE FABRICS", pty: "SRF", quality: "COTTON", group: "SHREE MASTER" },
    { id: "lot-4", date: "23/03/2026", srNo: "04/22/000011", lotNo: "030311", taka: 8, meter: 3100.0, party: "AAYUSH QUALITY", pty: "AUS", quality: "SATIN", group: "SINHA MASTER" },
    { id: "lot-5", date: "24/03/2026", srNo: "02/21/000002", lotNo: "011322", taka: 4, meter: 1560.0, party: "MEERA TEXTILES", pty: "MRT", quality: "POLY LAFER", group: "MEERA MASTER" }
];

// Mock Stage Data for each Lot
const MOCK_STAGE_DATA = {
    "lot-1": [{
        id: "s1", stageName: "GREY", subStageName: "CHECKING", taka: 3, meter: 1140.0, tp: 1, transDate: "20-03-2026 10:00", stageSrNo: "G001050",
        details: [
            { id: "d1", taka: 1, greyMtr: 380.0, stageMtr: 380.0, shortage: 0.0, balanceMtr: 380.0 },
            { id: "d2", taka: 2, greyMtr: 760.0, stageMtr: 760.0, shortage: 0.0, balanceMtr: 760.0 }
        ]
    }],
    "lot-2": [{
        id: "s2", stageName: "DYEING", subStageName: "PADDING", taka: 5, meter: 2200.0, tp: 2, transDate: "21-03-2026 14:30", stageSrNo: "G001052",
        details: [
            { id: "d3", taka: 5, greyMtr: 2250.0, stageMtr: 2200.0, shortage: 50.0, balanceMtr: 2200.0 }
        ]
    }],
    "lot-3": [{
        id: "s3", stageName: "PRINTING", subStageName: "ROTARY", taka: 2, meter: 850.5, tp: 3, transDate: "22-03-2026 09:15", stageSrNo: "G001055",
        details: [
            { id: "d4", taka: 2, greyMtr: 860.0, stageMtr: 850.5, shortage: 9.5, balanceMtr: 850.5 }
        ]
    }],
    "lot-4": [{
        id: "s4", stageName: "WASHING", subStageName: "FINISHING", taka: 8, meter: 3100.0, tp: 4, transDate: "23-03-2026 11:45", stageSrNo: "G001057",
        details: [
            { id: "d5", taka: 4, greyMtr: 1550.0, stageMtr: 1550.0, shortage: 0.0, balanceMtr: 1550.0 },
            { id: "d6", taka: 4, greyMtr: 1550.0, stageMtr: 1550.0, shortage: 0.0, balanceMtr: 1550.0 }
        ]
    }],
    "lot-5": [{
        id: "s5", stageName: "DELIVERY", subStageName: "DISPATCH", taka: 4, meter: 1560.0, tp: 6, transDate: "24-03-2026 16:00", stageSrNo: "G001059",
        details: [
            { id: "d7", taka: 4, greyMtr: 1600.0, stageMtr: 1560.0, shortage: 40.0, balanceMtr: 1560.0 }
        ]
    }]
};

// Mock Process Flow Data
const MOCK_PROCESS_FLOW = {
    "lot-1": [
        { id: "pf1", fromStage: "INWARD", toStage: "DYEING", processDate: "20-03-2026 10:00", batchNo: "B-001", taka: 3, meter: 1140.0, tp: 0, balTaka: 0, balMeter: 0, shortage: 0, processMaster: "SINHA MASTER", groupName: "SINHA MASTER", status: "Completed" },
        { id: "pf2", fromStage: "DYEING", toStage: "FINISHING", processDate: "21-03-2026 14:30", batchNo: "B-002", taka: 3, meter: 1140.0, tp: 0, balTaka: 0, balMeter: 0, shortage: 0, processMaster: "SINHA MASTER", groupName: "SINHA MASTER", status: "Completed" },
        { id: "pf3", fromStage: "FINISHING", toStage: "DELIVERY", processDate: "22-03-2026 16:00", batchNo: "B-003", taka: 3, meter: 1140.0, tp: 0, balTaka: 3, balMeter: 1140.0, shortage: 0, processMaster: "SINHA MASTER", groupName: "SINHA MASTER", status: "Pending" }
    ]
};

const LotPosition = () => {
    const { Colourdata } = useSelector((state) => state.ClientLogin);
    const iscolour = Colourdata?.data?.find(el => el.ExeName === "NEWMILLSTAGE");
    const iscolourDark = Colourdata?.data?.find(el => el.ExeName === "NEWMILLSTAGEDARK");
    const { theme } = useTheme();
    const isdark = theme;
    const dispatch = useDispatch();

    const [searchType, setSearchType] = useState("LotNo");
    const [searchVal, setSearchVal] = useState("");
    const [hasSearched, setHasSearched] = useState(false);
    const [filteredLots, setFilteredLots] = useState([]);
    const [selectedLotId, setSelectedLotId] = useState(null);

    const [masterDetails, setMasterDetails] = useState(null);
    const [stageData, setStageData] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [showProcessFlow, setShowProcessFlow] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;

    const processFlowRef = useRef(null);
    const groupId = Cookies.get("millmaster");

    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const { LotNoSearchdata } = useSelector((state) => state.MillstageEntry || {});

    const handleSearch = async (e) => {
        if (e) e.preventDefault();

        setSelectedLotId(null);
        setStageData([]);
        setExpandedRows({});
        setShowProcessFlow(false);
        setMasterDetails(null);


        if (!searchVal.trim()) {
            toast.warning(" Please enter a search value! ");
            return;
        }

        try {
            setHasSearched(true);
            await dispatch(
                LotNoSearch({
                    LotNo: searchVal,
                    LotOpt: searchType === "LotNo" ? 1 : 2,
                    GroupID: groupId,
                })
            ).unwrap();
        } catch (error) {
            console.error(error);
            // Fallback to Mock search
            const foundMock = MOCK_SAME_LOTS.filter(l => l.lotNo.includes(searchVal) || l.srNo.includes(searchVal));
            if (foundMock.length > 0) {
                setMasterDetails({
                    inwardDate: foundMock[0].date,
                    lotNoFull: foundMock[0].lotNo,
                    inwSrNo: foundMock[0].srNo,
                    party: foundMock[0].party,
                    totalNo: foundMock[0].taka,
                    meter: foundMock[0].meter,
                    qualityName: foundMock[0].quality,
                    groupName: foundMock[0].group
                });
                setFilteredLots(foundMock);
            } else {
                setFilteredLots([]);
                setMasterDetails(null);
                toast.error("No Data Found! Try searching a valid segment.");
            }
        }
    };

    useEffect(() => {
        if (LotNoSearchdata?.LotNoHelp?.length > 0) {

            setFilteredLots(
                LotNoSearchdata.LotNoHelp.map((item) => ({
                    InwardID: item.InwardID,
                    InwFirmId: item.InwFirmId,
                    InwAcYear: item.InwAcYear,
                    id: item.InwardID,
                    date: formatDate(item.InwDate || ""),
                    srNo: item.InwSrNo || "",
                    lotNo: item.LotNo || "",
                    Taka: item.Taka || "",
                    Meter: item.Meter || "",
                    AcName: item.AcName || "",
                    ShortACName: item.ShortACName || "",
                    QualityType: item.QualityType || "",
                    GroupName: item.GroupName || "",
                    QualityType: item.QualityType || "",
                }))
            );

            setSelectedLotId(null);
            setStageData([]);
            setExpandedRows({});
            setShowProcessFlow(false);
        } else if (hasSearched) {
            const foundMock = MOCK_SAME_LOTS.filter(l => l.lotNo.includes(searchVal) || l.srNo.includes(searchVal));
            if (foundMock.length > 0) {
                setMasterDetails({
                    inwardDate: foundMock[0].date,
                    lotNoFull: foundMock[0].lotNo,
                    inwSrNo: foundMock[0].srNo,
                    party: foundMock[0].party,
                    totalNo: foundMock[0].taka,
                    meter: foundMock[0].meter,
                    qualityName: foundMock[0].quality,
                    groupName: foundMock[0].group
                });
                setFilteredLots(foundMock);
                setSelectedLotId(null);
                setStageData([]);
                setExpandedRows({});
                setShowProcessFlow(false);
            } else {
                setFilteredLots([]);
                setMasterDetails(null);
                toast.error("No Data Found! Try searching a valid segment.");
            }
        }
    }, [LotNoSearchdata]);

    const selectSameLot = async (lot) => {
        setSelectedLotId(lot.id);

        setMasterDetails({
            inwardDate: lot.date || "",
            lotNoFull: lot.lotNo || "",
            party: lot.AcName || "",
            inwSrNo: lot.srNo || "",
            totalNo: lot.Taka || "",
            meter: Number(lot.Meter || 0),
            qualityName: lot.QualityType || "",
            groupName: lot.GroupName || "",
        });

        try {
            const response = await dispatch(
                LotPosition12({
                    InwardID: lot.InwardID,
                    InwFirmId: lot.InwFirmId,
                    InwAcYear: lot.InwAcYear,
                })
            ).unwrap();

            setStageData(
                (response?.LotPosition || []).map((item) => ({
                    id: item.TransID,
                    TransID: item.TransID,
                    InwardID: item.InwardID,
                    stageName: item.ToStageName || item.ToStageID,
                    subStageName: item.ToSubStageName || item.ToSubStageID,
                    taka: Number(item.Taka || 0),
                    meter: Number(item.Meter || 0),
                    tp: Number(item.Tp || 0),
                    transDate: item.TDate,
                    stageSrNo: item.StageSrNo,
                    details: [],
                }))
            );
        } catch (error) {
            console.error(error);
            const mock = MOCK_STAGE_DATA[lot.id];
            if (mock) {
                setStageData(mock);
            } else {
                setStageData([]);
                toast.error(" Lot Position API Failed , loading mock stages . ");
            }
        }

        setExpandedRows({});
        setShowProcessFlow(false);
    };

    const toggleExpand = async (row) => {
        setExpandedRows((prev) => ({
            ...prev,
            [row.id]: !prev[row.id],
        }));

        if (row.details && row.details.length > 0) return;

        try {
            const response = await dispatch(
                LotTakaDetail({
                    InwardID: row.InwardID,
                    TransID: row.TransID,
                })
            ).unwrap();

            setStageData((prev) =>
                prev.map((item) =>
                    item.id === row.id
                        ? {
                            ...item,
                            details: (response?.TakaDtl || []).map((d, index) => ({
                                id: index + 1,
                                taka: d.JobNo || (index + 1),
                                greyMtr: Number(d.GreyMtr || 0),
                                stageMtr: Number(d.StageMtr || 0),
                                shortage: Number(d.Shortage || 0),
                                balanceMtr: Number(d.balance || 0),
                            })),
                        }
                        : item
                )
            );
        } catch (error) {
            console.error(error);
            const mockLots = Object.values(MOCK_STAGE_DATA).flat();
            const matchedMock = mockLots.find(l => l.id === row.id);
            if (matchedMock) {
                setStageData(prev =>
                    prev.map(item =>
                        item.id === row.id ? { ...item, details: matchedMock.details } : item
                    )
                );
            } else {
                toast.error("Taka detail failed to load.");
            }
        }
    };

    // Styling constants mapped from Treatment page theme
    const primaryAccent = isdark === "light" ? iscolour?.Colour9 || "#1e293b" : "#f8fafc";
    const headerRowBg = isdark === "light" ? iscolour?.Colour4 || "#3b82f6" : iscolourDark?.Colour7 || "#1e293b";
    const tableHeaderColor = isdark === "light" ? iscolour?.Colour9 || "#ffffff" : "#ffffff";
    const primaryBg = isdark === "light" ? "#FFF9F5" : iscolourDark?.Colour10 || "#0f172a";
    const cardBackground = isdark === "light" ? "#ffffff" : iscolourDark?.Colour10 || "#1e293b";
    const borderColor = isdark === "light" ? iscolour?.Colour6 || "#e2e8f0" : iscolourDark?.Colour7 || "#334155";
    const textPrimary = isdark === "light" ? "#1e293b" : "#f8fafc";
    const textSecondary = isdark === "light" ? "#64748b" : "#94a3b8";
    const textColor = isdark === "light" ? "#475569" : "#cbd5e1";

    return (
        <div style={{ background: primaryBg, minHeight: "100vh", padding: "24px", color: textPrimary }}>

            {/* Top Search Card */}
            <Card className="mb-4" style={{
                border: `1px solid ${borderColor}`,
                background: cardBackground,
                borderRadius: "16px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.04)"
            }}>
                <Card.Body className="p-3 d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div>
                        <h4 className="fw-bold m-0" style={{ color: primaryAccent }}>Lot Position Dashboard</h4>
                        <p className="text-muted m-0" style={{ fontSize: "13px" }}>Search to view same-lot entries, stage details, and roll metrics</p>
                    </div>

                    <div className="d-flex align-items-center gap-3 flex-wrap">
                        {/* Segmented Controller (Replacing radios) */}
                        <div className="d-flex p-1 rounded-3" style={{ background: isdark === 'dark' ? '#0f172a' : '#f1f5f9' }}>
                            <button
                                onClick={() => setSearchType("LotNo")}
                                style={{
                                    border: "none",
                                    padding: "6px 14px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    borderRadius: "6px",
                                    background: searchType === "LotNo" ? primaryAccent : "transparent",
                                    color: searchType === "LotNo" ? "#ffffff" : textSecondary,
                                    transition: "all 0.2s ease"
                                }}
                            >
                                Lot No.
                            </button>
                            <button
                                onClick={() => setSearchType("InwSrNo")}
                                style={{
                                    border: "none",
                                    padding: "6px 14px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    borderRadius: "6px",
                                    background: searchType === "InwSrNo" ? primaryAccent : "transparent",
                                    color: searchType === "InwSrNo" ? "#ffffff" : textSecondary,
                                    transition: "all 0.2s ease"
                                }}
                            >
                                Inw Sr.No.
                            </button>
                        </div>

                        <form onSubmit={handleSearch} className="d-flex align-items-center gap-2">
                            <div style={{ position: "relative" }}>
                                <Search size={16} style={{
                                    position: "absolute",
                                    left: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: textSecondary
                                }} />
                                <input
                                    type="text"
                                    value={searchVal}
                                    onChange={e => setSearchVal(e.target.value)}
                                    placeholder="Enter search value..."
                                    style={{
                                        border: `1px solid ${borderColor}`,
                                        background: isdark === "light" ? "#f8fafc" : "#0f172a",
                                        color: textPrimary,
                                        borderRadius: "10px",
                                        padding: "8px 12px 8px 36px",
                                        fontSize: "13px",
                                        outline: "none",
                                        width: "200px"
                                    }}
                                />
                            </div>
                            <button
                                type="submit"
                                className="hover-scale-btn"
                                style={{
                                    border: "none",
                                    background: primaryAccent,
                                    color: "#ffffff",
                                    borderRadius: "10px",
                                    padding: "8px 16px",
                                    fontSize: "13px",
                                    fontWeight: "600"
                                }}
                            >
                                Search
                            </button>
                        </form>
                    </div>
                </Card.Body>
            </Card>



            <Row className="g-4">
                {/* 1. Same Lot Entries Table (Displays after Search) */}
                {hasSearched && (
                    <Col xs={12}>
                        <Card style={{
                            border: `1px solid ${borderColor}`,
                            background: cardBackground,
                            borderRadius: "16px",
                            overflow: "hidden",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.02)"
                        }}>
                            <div className="p-3 d-flex justify-content-between align-items-center" style={{ background: isdark === "light" ? "rgba(0,0,0,0.01)" : "rgba(255,255,255,0.01)", borderBottom: `1px solid ${borderColor}` }}>
                                <h5 className="fw-bold m-0" style={{ color: primaryAccent }}>Same Lot Entries</h5>
                                <Badge bg="primary" style={{ background: primaryAccent, padding: "6px 12px", borderRadius: "8px" }}>
                                    {filteredLots.length} Results
                                </Badge>
                            </div>

                            {filteredLots.length === 0 ? (
                                <div className="text-center py-5 text-muted">
                                    <Search size={36} className="mb-2 opacity-50" />
                                    <p className="m-0" style={{ fontSize: "13px" }}>No Same Lot Entries found.</p>
                                </div>
                            ) : (
                                <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "285px" }} className="theme-scroll">
                                    <table className="table table-striped table-hover mb-0" style={{ minWidth: "800px" }}>
                                        <thead>
                                            <tr style={{
                                                color: tableHeaderColor,
                                                padding: "12px 16px",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 10,
                                                background: headerRowBg,
                                                width: "80px",
                                                textAlign: "center"
                                            }}>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600", width: "80px", textAlign: "center" }}>Select</th>
                                                {/* <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Date</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Sr No</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>LotNo</th> */}

                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600", width: "80px", textAlign: "center" }}>Date</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Sr No</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Lot No</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Taka</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Meter</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Account Name</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Short Name</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Quality</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Group</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredLots.map((lot) => {
                                                const isSelected = selectedLotId === lot.id;

                                                return (
                                                    <tr
                                                        key={lot.id}
                                                        onClick={() => selectSameLot(lot)}
                                                        style={{
                                                            cursor: "pointer",
                                                            background: isSelected
                                                                ? (isdark === "light"
                                                                    ? "rgba(59, 130, 246, 0.08)"
                                                                    : "rgba(59, 130, 246, 0.15)")
                                                                : "transparent"
                                                        }}
                                                    >
                                                        <td className="p-3 text-center align-middle">
                                                            <div
                                                                style={{
                                                                    width: "16px",
                                                                    height: "16px",
                                                                    borderRadius: "50%",
                                                                    border: `2px solid ${isSelected ? primaryAccent : borderColor}`,
                                                                    background: isSelected ? primaryAccent : "transparent",
                                                                    margin: "0 auto",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                {isSelected && (
                                                                    <div
                                                                        style={{
                                                                            width: "6px",
                                                                            height: "6px",
                                                                            background: "#fff",
                                                                            borderRadius: "50%"
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                                                            {lot.date}
                                                        </td>

                                                        <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                                                            {lot.srNo}
                                                        </td>

                                                        <td
                                                            className="p-3 align-middle fw-bold"
                                                            style={{
                                                                fontSize: "13px",
                                                                color: isSelected ? primaryAccent : "inherit"
                                                            }}
                                                        >
                                                            {lot.lotNo}
                                                        </td>

                                                        <td
                                                            className="p-3 align-middle text-end"
                                                            style={{ fontSize: "13px" }}
                                                        >
                                                            {lot.Taka}
                                                        </td>

                                                        <td
                                                            className="p-3 align-middle text-end"
                                                            style={{ fontSize: "13px" }}
                                                        >
                                                            {Number(lot.Meter || 0).toFixed(2)}
                                                        </td>

                                                        <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                                                            {lot.AcName}
                                                        </td>

                                                        <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                                                            {lot.ShortACName}
                                                        </td>

                                                        <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                                                            {lot.QualityType}
                                                        </td>

                                                        <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                                                            {lot.GroupName}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Card>
                    </Col>
                )}

                {/* Master Details Panel (Always visible once search is triggered) */}
                {hasSearched && masterDetails && (
                    <Col>
                        <div
                            style={{
                                background: isdark === "light" ? "#f8fafc" : iscolourDark?.Colour9,
                                padding: "15px",
                                border: `1px solid ${borderColor}`,
                                // background: cardBackground,
                                borderRadius: "16px",

                            }}
                            className="mb-3"
                        >
                            <Row className="g-3">
                                <DetailItem label="Inward Date" value={formatDate(masterDetails?.inwardDate)} isdark={isdark} labelColor={textColor} />
                                <DetailItem label="LotNo" value={masterDetails?.lotNoFull} isdark={isdark} labelColor={textColor} />
                                <DetailItem label="Party" value={masterDetails?.party} isdark={isdark} labelColor={textColor} />
                                <DetailItem label="Inw Sr.No." value={masterDetails?.inwSrNo} isdark={isdark} labelColor={textColor} />
                                <DetailItem label="Total No." value={masterDetails?.totalNo} isdark={isdark} labelColor={textColor} />
                                <DetailItem label="Meter" value={masterDetails?.meter ? masterDetails.meter.toFixed(2) : ""} isdark={isdark} labelColor={textColor} />
                                <DetailItem label="Quality Name" value={masterDetails?.qualityName} isdark={isdark} labelColor={textColor} colWidth={12} />
                                <DetailItem label="Group Name" value={masterDetails?.groupName} isdark={isdark} labelColor={textColor} colWidth={12} />

                            </Row>
                        </div>
                    </Col>

                )}

                {/* 2. Process Detail Table (Displays after selecting a Lot from the list) */}
                {selectedLotId && (
                    <Col xs={12}>
                        <Card style={{
                            border: `1px solid ${borderColor}`,
                            background: cardBackground,
                            borderRadius: "16px",
                            overflow: "hidden",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.02)"
                        }}>
                            <div className="p-3 d-flex justify-content-between align-items-center" style={{ background: isdark === "light" ? "rgba(0,0,0,0.01)" : "rgba(255,255,255,0.01)", borderBottom: `1px solid ${borderColor}` }}>
                                <h5 className="fw-bold m-0" style={{ color: primaryAccent }}>Process Detail</h5>
                                <button
                                    onClick={() => {
                                        setShowProcessFlow(true);
                                        setTimeout(() => {
                                            processFlowRef.current?.scrollIntoView({ behavior: 'smooth' });
                                        }, 100);
                                    }}
                                    style={{
                                        border: `1px solid ${borderColor}`,
                                        background: isdark === 'light' ? '#fff' : '#0f172a',
                                        color: primaryAccent,
                                        padding: "6px 12px",
                                        borderRadius: "8px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px"
                                    }}
                                    className="hover-scale-btn"
                                >
                                    <FileText size={14} /> Process Flow Details
                                </button>
                            </div>

                            {stageData.length === 0 ? (
                                <div className="text-center py-5 text-muted">No processed stages found for this Lot.</div>
                            ) : (
                                <div style={{ overflowX: "auto" }}>
                                    <table className="table mb-0" style={{ minWidth: "900px" }}>
                                        <thead>
                                            <tr style={{ background: headerRowBg }}>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600", width: "80px", textAlign: "center" }}>Expand</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>Stage Name</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>SubStage Name</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600", textAlign: "right" }}>Taka</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600", textAlign: "right" }}>Meter</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600", textAlign: "right" }}>Tp</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>TransDate</th>
                                                <th style={{ color: tableHeaderColor, padding: "12px 16px", fontSize: "13px", fontWeight: "600" }}>StageSrNo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {stageData.map(step => {
                                                const isExpanded = expandedRows[step.id];
                                                return (
                                                    <React.Fragment key={step.id}>
                                                        <tr
                                                            style={{ borderBottom: `1px solid ${borderColor}` }}
                                                            onClick={() => toggleExpand(step)}
                                                            className="cursor-pointer"
                                                        >
                                                            <td className="p-3 text-center align-middle" onClick={(e) => e.stopPropagation()}>
                                                                <button
                                                                    onClick={() => toggleExpand(step)}
                                                                    style={{ background: "transparent", border: "none", color: primaryAccent }}
                                                                >
                                                                    {isExpanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                                                                </button>
                                                            </td>
                                                            <td className="p-3 align-middle fw-bold" style={{ fontSize: "13px" }}>{step.stageName}</td>
                                                            <td className="p-3 align-middle" style={{ fontSize: "13px" }}>{step.subStageName}</td>
                                                            <td className="p-3 align-middle text-end fw-semibold" style={{ fontSize: "13px" }}>{step.taka}</td>
                                                            <td className="p-3 align-middle text-end" style={{ fontSize: "13px" }}>{step.meter.toFixed(2)}</td>
                                                            <td className="p-3 align-middle text-end" style={{ fontSize: "13px" }}>{step.tp}</td>
                                                            <td className="p-3 align-middle text-muted" style={{ fontSize: "12px" }}>{step.transDate}</td>
                                                            <td className="p-3 align-middle fw-semibold" style={{ fontSize: "13px" }}>{step.stageSrNo}</td>
                                                        </tr>

                                                        {/* 3. Expanded Inner Roll/Taka Table Details */}
                                                        {isExpanded && (
                                                            <tr>
                                                                <td colSpan={8} style={{ padding: "12px 16px 20px 48px", background: isdark === "light" ? "#fbfbfa" : "#111827" }}>
                                                                    <div className="shadow-sm border rounded-3 overflow-hidden" style={{ borderColor: borderColor, maxWidth: "800px" }}>
                                                                        <div className="p-2 d-flex align-items-center gap-2" style={{ background: isdark === "light" ? "#f1f5f9" : "#1e293b", borderBottom: `1px solid ${borderColor}` }}>
                                                                            <Box size={14} style={{ color: primaryAccent }} />
                                                                            <span className="fw-bold" style={{ fontSize: "12px" }}>Taka Level Specifications ({step.details.length} Items)</span>
                                                                        </div>

                                                                        {step.details.length === 0 ? (
                                                                            <div className="text-center py-3 text-muted" style={{ fontSize: "12px" }}>Loading taka roll details...</div>
                                                                        ) : (
                                                                            <div
                                                                                className="theme-scroll"
                                                                                style={{
                                                                                    maxHeight: "250px",
                                                                                    overflowY: "auto",
                                                                                    overflowX: "hidden"
                                                                                }}
                                                                            >
                                                                                <table className="table mb-0">
                                                                                    <thead
                                                                                        style={{
                                                                                            background: isdark === "light" ? "#f8fafc" : "#111827",
                                                                                            position: "sticky",
                                                                                            top: 0,
                                                                                            zIndex: 10
                                                                                        }}
                                                                                    >
                                                                                        <tr>
                                                                                            <th className="p-2 text-center" style={{ fontSize: "11px", borderBottom: `1px solid ${borderColor}` }}>
                                                                                                Taka / Job No
                                                                                            </th>
                                                                                            <th className="p-2 text-end" style={{ fontSize: "11px", borderBottom: `1px solid ${borderColor}` }}>
                                                                                                Grey Mtr
                                                                                            </th>
                                                                                            <th className="p-2 text-end" style={{ fontSize: "11px", borderBottom: `1px solid ${borderColor}` }}>
                                                                                                Stage Mtr
                                                                                            </th>
                                                                                            <th className="p-2 text-end" style={{ fontSize: "11px", borderBottom: `1px solid ${borderColor}` }}>
                                                                                                Shortage
                                                                                            </th>
                                                                                            <th className="p-2 text-end" style={{ fontSize: "11px", borderBottom: `1px solid ${borderColor}` }}>
                                                                                                Balance Mtr
                                                                                            </th>
                                                                                        </tr>
                                                                                    </thead>

                                                                                    <tbody>
                                                                                        {step.details.map((det) => (
                                                                                            <tr key={det.id} style={{ borderBottom: `1px solid ${borderColor}` }}>
                                                                                                <td className="p-2 text-center align-middle" style={{ fontSize: "12px" }}>
                                                                                                    {det.taka}
                                                                                                </td>

                                                                                                <td className="p-2 text-end align-middle" style={{ fontSize: "12px" }}>
                                                                                                    {det.greyMtr.toFixed(2)}
                                                                                                </td>

                                                                                                <td className="p-2 text-end align-middle" style={{ fontSize: "12px" }}>
                                                                                                    {det.stageMtr.toFixed(2)}
                                                                                                </td>

                                                                                                <td
                                                                                                    className="p-2 text-end align-middle"
                                                                                                    style={{
                                                                                                        fontSize: "12px",
                                                                                                        color: det.shortage > 0 ? "#ef4444" : "inherit",
                                                                                                        fontWeight: det.shortage > 0 ? "600" : "normal"
                                                                                                    }}
                                                                                                >
                                                                                                    {det.shortage.toFixed(2)}
                                                                                                </td>

                                                                                                <td className="p-2 text-end align-middle" style={{ fontSize: "12px" }}>
                                                                                                    {det.balanceMtr.toFixed(2)}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                        <tfoot style={{ background: isdark === "light" ? "#cbd5e1" : "#334155", fontWeight: "700" }}>
                                            <tr>
                                                <td colSpan={3} className="p-3 text-end fw-bold" style={{ fontSize: "13px" }}>Total Summary:</td>
                                                <td className="p-3 text-end fw-bold" style={{ fontSize: "13px" }}>{stageData.reduce((acc, curr) => acc + curr.taka, 0)}</td>
                                                <td className="p-3 text-end fw-bold" style={{ fontSize: "13px" }}>{stageData.reduce((acc, curr) => acc + curr.meter, 0).toFixed(2)}</td>
                                                <td className="p-3 text-end fw-bold" style={{ fontSize: "13px" }}>{stageData.reduce((acc, curr) => acc + curr.tp, 0)}</td>
                                                <td colSpan={2}></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}
                        </Card>
                    </Col>
                )}
            </Row>



            {/* Redesigned Process Flow Slide-down Detail Panel */}
            {showProcessFlow && selectedLotId && (
                <div ref={processFlowRef} className="mt-4">
                    <Card style={{
                        border: `1px solid ${borderColor}`,
                        background: cardBackground,
                        borderRadius: "16px",
                        overflow: "hidden",
                    }}>
                        <Card.Header className="p-3 d-flex justify-content-between align-items-center" style={{ background: isdark === "light" ? "rgba(0,0,0,0.01)" : "rgba(255,255,255,0.01)", borderBottom: `1px solid ${borderColor}` }}>
                            <div className="d-flex align-items-center gap-2">
                                <TrendingUp size={16} style={{ color: primaryAccent }} />
                                <h6 className="fw-bold m-0" style={{ color: primaryAccent }}>Process Flow Specification</h6>
                            </div>
                            <button
                                onClick={() => setShowProcessFlow(false)}
                                style={{ background: "transparent", border: "none", color: "#ef4444" }}
                                className="hover-scale-btn"
                            >
                                <X size={18} />
                            </button>
                        </Card.Header>
                        <Card.Body className="p-3">
                            {(!MOCK_PROCESS_FLOW[selectedLotId] || MOCK_PROCESS_FLOW[selectedLotId].length === 0) ? (
                                <div className="text-center py-4 text-muted">No process flow details available.</div>
                            ) : (
                                <div style={{ overflowX: "auto", border: `1px solid ${borderColor}`, borderRadius: "10px" }}>
                                    <table className="table table-striped table-hover mb-0" style={{ minWidth: "1100px" }}>
                                        <thead style={{ background: isdark === "light" ? "#f1f5f9" : "#1e293b" }}>
                                            <tr>
                                                <th className="p-2" style={{ fontSize: "12px" }}>Sr</th>
                                                <th className="p-2" style={{ fontSize: "12px" }}>From Stage</th>
                                                <th className="p-2" style={{ fontSize: "12px" }}>To Stage</th>
                                                <th className="p-2" style={{ fontSize: "12px" }}>Process Date</th>
                                                <th className="p-2" style={{ fontSize: "12px" }}>Batch No</th>
                                                <th className="p-2 text-end" style={{ fontSize: "12px" }}>Taka</th>
                                                <th className="p-2 text-end" style={{ fontSize: "12px" }}>Meter</th>
                                                <th className="p-2 text-end" style={{ fontSize: "12px" }}>Tp</th>
                                                <th className="p-2 text-end" style={{ fontSize: "12px" }}>Bal Taka</th>
                                                <th className="p-2 text-end" style={{ fontSize: "12px" }}>Bal Meter</th>
                                                <th className="p-2 text-end" style={{ fontSize: "12px" }}>Shortage</th>
                                                <th className="p-2" style={{ fontSize: "12px" }}>Process Master</th>
                                                <th className="p-2" style={{ fontSize: "12px" }}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {MOCK_PROCESS_FLOW[selectedLotId].map((flow, idx) => (
                                                <tr key={flow.id} style={{ borderBottom: `1px solid ${borderColor}` }}>
                                                    <td className="p-2 align-middle" style={{ fontSize: "12px" }}>{idx + 1}</td>
                                                    <td className="p-2 align-middle fw-semibold" style={{ fontSize: "12px" }}>{flow.fromStage}</td>
                                                    <td className="p-2 align-middle fw-semibold" style={{ fontSize: "12px" }}>{flow.toStage}</td>
                                                    <td className="p-2 align-middle" style={{ fontSize: "12px" }}>{flow.processDate}</td>
                                                    <td className="p-2 align-middle" style={{ fontSize: "12px" }}>{flow.batchNo}</td>
                                                    <td className="p-2 align-middle text-end fw-semibold" style={{ fontSize: "12px" }}>{flow.taka}</td>
                                                    <td className="p-2 align-middle text-end" style={{ fontSize: "12px" }}>{flow.meter.toFixed(2)}</td>
                                                    <td className="p-2 align-middle text-end" style={{ fontSize: "12px" }}>{flow.tp}</td>
                                                    <td className="p-2 align-middle text-end" style={{ fontSize: "12px" }}>{flow.balTaka}</td>
                                                    <td className="p-2 align-middle text-end" style={{ fontSize: "12px" }}>{flow.balMeter.toFixed(2)}</td>
                                                    <td className="p-2 align-middle text-end" style={{ fontSize: "12px", color: flow.shortage > 0 ? "#ef4444" : "inherit" }}>{flow.shortage.toFixed(2)}</td>
                                                    <td className="p-2 align-middle" style={{ fontSize: "12px" }}>{flow.processMaster}</td>
                                                    <td className="p-2 align-middle" style={{ fontSize: "12px" }}>
                                                        <Badge bg={flow.status === 'Completed' ? 'success' : 'warning'} style={{ padding: "4px 8px", fontSize: "10px" }}>
                                                            {flow.status}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot style={{ background: isdark === "light" ? "#cbd5e1" : "#334155", fontWeight: "700" }}>
                                            <tr>
                                                <td colSpan={5} className="p-2 text-end fw-bold" style={{ fontSize: "12px" }}>Total:</td>
                                                <td className="p-2 text-end fw-bold" style={{ fontSize: "12px" }}>{MOCK_PROCESS_FLOW[selectedLotId].reduce((acc, c) => acc + c.taka, 0)}</td>
                                                <td className="p-2 text-end fw-bold" style={{ fontSize: "12px" }}>{MOCK_PROCESS_FLOW[selectedLotId].reduce((acc, c) => acc + c.meter, 0).toFixed(2)}</td>
                                                <td className="p-2 text-end fw-bold" style={{ fontSize: "12px" }}>{MOCK_PROCESS_FLOW[selectedLotId].reduce((acc, c) => acc + c.tp, 0)}</td>
                                                <td className="p-2 text-end fw-bold" style={{ fontSize: "12px" }}>{MOCK_PROCESS_FLOW[selectedLotId].reduce((acc, c) => acc + c.balTaka, 0)}</td>
                                                <td className="p-2 text-end fw-bold" style={{ fontSize: "12px" }}>{MOCK_PROCESS_FLOW[selectedLotId].reduce((acc, c) => acc + c.balMeter, 0).toFixed(2)}</td>
                                                <td colSpan={3}></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </div>
            )}
        </div>
    );
};

const DetailItem = ({ label, value, labelColor, colWidth = 4, labelWidth = "120px", isdark }) => {
    return (
        <Col xs={12} sm={6} md={colWidth}>
            <div className="d-flex align-items-center text-sm" style={{ gap: "10px" }}>
                <span style={{
                    color: labelColor,
                    width: labelWidth,
                    minWidth: labelWidth,
                    textAlign: "right",
                    fontWeight: "600",
                    fontSize: "14px"
                }}>
                    {label} :
                </span>
                <span style={{
                    flex: 1,
                    fontWeight: "700",
                    color: isdark === "light" ? "#0f172a" : "#fff",
                    fontSize: "14px"
                }}>
                    {value || "—"}
                </span>
            </div>
        </Col>
    );
};

export default LotPosition;
